import { find } from "lodash";
import { ABCampaigns, ABCampaign, ABTestVariation } from "../types";

/**
 * Manages AB test campaigns independently of any specific provider
 * Follows Single Responsibility Principle
 */
export class ABTestCampaignManager {
  private campaigns: ABCampaigns;

  constructor(campaigns: ABCampaigns = {}) {
    this.campaigns = campaigns;
  }

  /**
   * Get variant for a specific campaign
   */
  getVariant(campaignKey: string): string | undefined {
    const campaign = this.campaigns[campaignKey];
    return campaign?.variant;
  }

  /**
   * Set variant for a campaign
   */
  setVariant(campaignId: string, variant: string): void {
    const campaign = find(this.campaigns, { id: campaignId });
    if (!campaign) {
      console.warn(`AB Test: Campaign with ID "${campaignId}" not found`);
      return;
    }
    campaign.variant = variant;
  }

  /**
   * Get all campaigns
   */
  getAllCampaigns(): ABCampaigns {
    return { ...this.campaigns };
  }

  /**
   * Add or update a campaign
   */
  setCampaign(key: string, campaign: ABCampaign): void {
    this.campaigns[key] = campaign;
  }

  /**
   * Update campaigns from provider variation
   */
  updateCampaignsFromVariations(variation: ABTestVariation): void {
    if (!variation) return;

    Object.keys(variation).forEach((campaignId) => {
      this.setVariant(campaignId, variation[campaignId]);
    });
  }
}
